// extracted by mini-css-extract-plugin
module.exports = {"login-dialog":"LoginModal_login-dialog__2kzI9","image":"LoginModal_image__1CyKx","actions":"LoginModal_actions__1hW87","content":"LoginModal_content__LM4bZ"};